import React from 'react'
import PropTypes from 'prop-types'
// import { useSelector } from 'react-redux'
import { Grid } from '@mui/material'

// import { Logger, LoggerTypes } from '../../../utils'
import './style.scss'

export const Page = ({ children, className }) => {
  // const account = useSelector((state) => state.account)
  // Logger.trace(LoggerTypes.CONTAINER, 'Page.render()', { account })

  return (
    <div className={`commonPage ${className}`}>
      <Grid
        container={true}
        item={true}
        xs={12}
        direction="row-reverse"
        justifyContent="space-between"
        alignItems="stretch"
        className="commonPage_container"
        spacing={0}
      >
        {children}
      </Grid>
    </div>
  )
}

Page.displayName = 'Page'

Page.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node.isRequired
}

Page.defaultProps = {
  className: ''
}
